export default "__VITE_ASSET__DKDtJwJq__"